import { render, staticRenderFns } from "./AddNewBebambiCustomerAddress.vue?vue&type=template&id=3b1c301e&scoped=true&"
import script from "./AddNewBebambiCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./AddNewBebambiCustomerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c301e",
  null
  
)

export default component.exports